
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2ce33ec3&scoped=true!stylus-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./item-statics-dish.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./item-statics-dish.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2ce33ec3!../../node_modules/vue-loader/lib/selector?type=template&index=0!./item-statics-dish.vue"),
  /* scopeId */
  "data-v-2ce33ec3",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comps/item-statics-dish.vue
// module id = 755
// module chunks = 34